import { formatInterviewSchedule } from 'features/sendouts/common/utils';
import startCase from 'lodash/startCase';

export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    interviewType: item.interviewTypeTitle ?? null,
    interviewDate: formatInterviewSchedule({
      startTimestamp: item.startTimestamp,
      endTimestamp: item.endTimestamp,
      timezone: item.timezone
    }),
    otherInterviewer: item.otherInterviewer?.fullName
      ? startCase(item.otherInterviewer.fullName)
      : null
  }));
  return { ...response, data: { ...response.data, data: formattedData } };
};
